import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ForcePasswordChange() {
  const { user, logout, refreshUser } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [next2, setNext2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error("La nuova password deve avere almeno 6 caratteri"); return; }
    if (next !== next2) { toast.error("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password aggiornata");
      await refreshUser();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen grain flex items-center justify-center p-6 bg-[#0A0A0C]">
      <div data-testid="force-password-change" className="w-full max-w-md bg-[#1C1C1F] border border-white/10 rounded-xl p-8">
        <div className="text-[#00E676] font-display font-black text-3xl tracking-tighter mb-1">Fuma c'anduma</div>
        <div className="flex items-center gap-2 text-zinc-300 mb-2"><KeyRound className="h-5 w-5 text-[#00E676]" /> Cambio password obbligatorio</div>
        <p className="text-sm text-zinc-500 mb-6">Per motivi di sicurezza, imposta una nuova password prima di continuare. Account: <span className="text-zinc-300">{user?.email}</span></p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Password attuale</Label><Input data-testid="force-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required className="bg-[#0A0A0C] border-white/10 mt-1.5" /></div>
          <div><Label>Nuova password</Label><Input data-testid="force-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} required className="bg-[#0A0A0C] border-white/10 mt-1.5" /></div>
          <div><Label>Conferma nuova password</Label><Input data-testid="force-confirm" type="password" value={next2} onChange={(e) => setNext2(e.target.value)} required className="bg-[#0A0A0C] border-white/10 mt-1.5" /></div>
          <Button data-testid="force-submit" disabled={loading} className="w-full bg-[#00E676] text-black hover:bg-[#00c766] font-semibold rounded-full">{loading ? "Attendere…" : "Imposta nuova password"}</Button>
        </form>
        <button className="mt-6 text-xs text-zinc-500 hover:text-red-400" onClick={logout}>Esci</button>
      </div>
    </div>
  );
}
